import { StaticFile } from "../file/StaticFile"
import { Gesture, gestureLayers } from "./BaseGesture"

class SidebarItemClickToSelectOrOpen extends Gesture {
  override layer = gestureLayers.sidebar

  override reset() {
  }

  isOverChevron(event: MouseEvent) {
    const { sidebarChevronClass } = useGlobals()
    return getFirstMatchingParent(event.target, e => e.classList && e.classList.contains(sidebarChevronClass))
  }

  override async onMouseUp(mouse: MouseEvent) {
    const { isPrimaryClick, getSidebarFavoritesFileFromEvent, getSidebarFavoritesSearchFromEvent, getSidebarFavoritesConversationFromEvent, state: gestureState, getSidebarRootFromEvent, isOverSidebar, clickedCloseEnough, getFileIdFromEvent } = useGestures()
    const { navigateToFile, navigateToSearch, navigateToConversation, navigateToSharedFolder, navigateToSelfHome, navigateToSelfArchive } = useNavigation()
    const { emitInterfaceEvent } = useEvents()

    if (!isPrimaryClick(mouse) || !isOverSidebar(mouse))
      return this.reset()

    // if the position of the mouse is where it was on mouse down, then we're a click
    if (!gestureState.value.mouseDown || !clickedCloseEnough(gestureState.value.mouseDown, mouse))
      return this.reset()

    // if we clicked on the chevron, then we ignore the click
    if (this.isOverChevron(mouse)) {
      this.debug("Ignoring click on chevron (handled in component")
      return this.reset()
    }

    const root = getSidebarRootFromEvent(mouse)
    if (root) {
      this.capture()
      emitInterfaceEvent("afterHardBlur", {})
      if (root.isUserHomeFolder())
        navigateToSelfHome()
      else if (root.isUserArchiveFolder())
        navigateToSelfArchive()
      else
        navigateToSharedFolder(root)
      return this.reset()
    }

    // Favorites files

    const file = getSidebarFavoritesFileFromEvent(mouse)
    if (file) {
      this.capture()
      emitInterfaceEvent("afterHardBlur", {})
      navigateToFile(file)
    }

    const search = getSidebarFavoritesSearchFromEvent(mouse)
    if (search) {
      this.capture()
      emitInterfaceEvent("afterHardBlur", {})
      navigateToSearch(search, false)
    }

    const conversation = getSidebarFavoritesConversationFromEvent(mouse)
    if (conversation) {
      this.capture()
      emitInterfaceEvent("afterHardBlur", {})
      navigateToConversation(conversation)
    }

    // items in subfolders (not part of favorites or roots)
    const fileId = getFileIdFromEvent(mouse)
    if (fileId) {
      this.capture()
      emitInterfaceEvent("afterHardBlur", {})
      const file = StaticFile.blank(fileId)
      navigateToFile(file)
    }

    return this.reset()
  }
}

const sidebarItemClickToSelectOrOpen = new SidebarItemClickToSelectOrOpen()
export default function () {
  return sidebarItemClickToSelectOrOpen
}
